const groupTypes = {
  required: 1,
  additional: 2,
};

const groupTypesString = {
  [groupTypes.required]: 'Requerido',
  [groupTypes.additional]: 'Adicional',
};

const getGroupNameByType = (type) => {
  return groupTypesString[type];
};

export { groupTypes, groupTypesString, getGroupNameByType };
